/**
 * Default ordering for terminal task-queue lists (/storage/tasks/queue).
 * Higher priority values first; tie-break by id ascending.
 */
export const PICKING_QUEUE_LIST_ORDER_BY = [
  { type: 'field', field: 'priority', direction: 'desc' },
  { type: 'field', field: 'id', direction: 'asc' }
]

/**
 * Prepends priority + id ordering. Any existing `order-by` entries follow.
 *
 * @param {object} query
 * @returns {object}
 */
export function withPickingQueueListOrderBy (query = {}) {
  const extra = Array.isArray(query['order-by']) ? query['order-by'] : []
  return {
    ...query,
    'order-by': [...PICKING_QUEUE_LIST_ORDER_BY, ...extra]
  }
}
